import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import AuthStore from '@store/AuthStore';
import { runInAction } from 'mobx';
import { addCommas, removeNonNumeric, removeCommas } from '@helper';
import {
    callQryCollateralCal,
    callEditCollateral,
    getFindBusinessTime,
} from '@api';

const initialState = {
    certificateNumber: '',
    amount: '',
    mRate: '',
    borrowingAmount: 0,
    collateralApplyModalVisible: false,
    certModalVisible: false,
    highGradeModalVisible: false,
    declareModalVisible: false,
    highGradeCollateralSwitch: false,
    trialBalanceComplete: false,
    TransMsg: '作業中，請稍後再申請！',
    collateralUIs: [
        {
            stockNo: '',
            stockName: '',
            qty: 0,
            closePrice: 0,
            marketVal: 0,
        },
    ],
    collateralStockUIs: [
        {
            stockNo: '',
            stockName: '',
            stockQty: 0,
            closePrice: 0,
            insiderFlag: 0,
            marketVal: 0,
            accommodating: 0,
        },
    ],
    transType: '',
    transInfoVisible: true,
    lendCollateralSwitchVisible: true,
    isLoading: false,
    loadingFailed: false,
    msg: '',
    transFlagModalVisible: false,
    applyDisabled: false,
};
const api = {
    qryColCal: callQryCollateralCal,
    editCollateral: callEditCollateral,
    getBusinessTime: getFindBusinessTime,
};
const TrialBalanceStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...StoreAction(initialState),
        ...api,
        async getQryColCal() {
            const res = await this.qryColCal();
            this.collateralUIs = res.data.item.collateralUIs;
        },
        async getColCalStock() {
            runInAction(async () => {
                const res = await this.qryColCal();
                this.collateralStockUIs = res.data.item.collateralStockUIs.map(
                    items => ({
                        ...items,
                        repayStockQty: 0,
                    })
                );
            });
        },
        async getApplyCollateral() {
            //  this.updateData('applyDisabled', true);
            this.updateData('isLoading', true);
            const postData = {
                calCollateralStockForms: this.collateralStockUIs
                    .filter(stock => stock.repayStockQty > 0)
                    .map(
                        ({ repayStockQty, marketVal, stockNo, stockName }) => ({
                            collateralQty: repayStockQty,
                            marketValue: marketVal,
                            stockNo: stockNo,
                            collateralName: stockName,
                        })
                    ),
                certificateNumber: this.certificateNumber,
            };
            const res = await this.editCollateral(postData);
            const code = parseInt(res.data.code);
            const message = res.data.message;
            if (res) {
                this.updateData('applyDisabled', false);
                this.updateData('isLoading', false);
                this.updateData('trialBalanceComplete', true);
                if (code) {
                    this.updateData('loadingFailed', true);
                    this.updateData('msg', message);
                    this.updateData('declareModalVisible', false);
                } else {
                    this.updateData('declareModalVisible', false);
                }
            }
            // if (res.status === 200 && !code) {
            //     this.updateData('declareModalVisible', false);
            //     this.updateData('trialBalanceComplete', true);
            // } else {
            //     this.updateData('declareModalVisible', false);
            // }
        },
        async getCollateralBusinessTime() {
            const res = await this.getBusinessTime();
            const transType = res.item.code;
            const highGradeSwitch =
                res.item.switchOptions.HighGradeCollateralSwitch;
            if (parseInt(highGradeSwitch)) {
                if (highGradeSwitch === '1') {
                    this.updateData('highGradeCollateralSwitch', true);
                } else {
                    this.updateData('highGradeCollateralSwitch', false);
                }
            } else {
                this.updateData('highGradeCollateralSwitch', false);
            }
            const lendCollateralSwitchMessage =
                res.item.switchOffMessage.lendCollateralSwitchMessage;
            this.assignData({ transType, lendCollateralSwitchMessage });
            if (transType === 'Y' || transType === '' || transType === 'E4') {
                this.updateData('transInfoVisible', true);
            } else {
                this.updateData('transInfoVisible', false);
            }
            const lendCollateralSwitch =
                res.item.switchOptions.lendCollateralSwitch;
            if (parseInt(lendCollateralSwitch)) {
                this.updateData('lendCollateralSwitchVisible', true);
                return parseInt(lendCollateralSwitch);
            } else {
                this.updateData('lendCollateralSwitchVisible', false);
                return parseInt(lendCollateralSwitch);
            }
        },
        closeCollateralApplyModal() {
            this.collateralApplyModalVisible = false;
        },
        closeCertModal() {
            this.certModalVisible = false;
        },
        closeHighGradeModal() {
            this.highGradeModalVisible = false;
        },
        closeDeclareModal() {
            this.declareModalVisible = false;
        },
        setCount({ index, value }) {
            this.collateralStockUIs[index].repayStockQty = value;
        },
        closeTransFlagModal() {
            this.transFlagModalVisible = false;
        },
    }));

export default TrialBalanceStore;
